export const storage = {
    DP_CURBSIDE_CHECKIN_INFO: 'DP_CURBSIDE_CHECKIN_INFO',
    DP_CURBSIDE_PRODUCT_INFO: 'DP_CURBSIDE_PRODUCT_INFO',
};

export const nSSRReturnStatus = {
    Completed: 'Complete',
    InProgress: 'in Progress',
    Cancelled: 'Canceled',
};

export const nSSRDateStatus = {
    Completed: 'Completed',
    InProgress: 'Started',
    Cancelled: 'Canceled',
};

export const returnReasons = [
    { key: 'select', value: 'Select a reason ...' },
    { key: 'RETURN_DPD_WRONG_SIZE', value: 'Sizing Issues' },
    { key: 'RETURN_CM_QUALITY', value: 'Not What I Was Expecting' },
    { key: 'RETURN_DELIVERED_PRODUCT_DIFFERENT', value: 'Incorrect Item' },
    { key: 'RETURN_DEFECTIVE_ITEM', value: 'Defective' },
    { key: 'RETURN_CM_DONT_WANT', value: "Don't Want The Product Anymore" },
    { key: 'RETURN_OTHER', value: 'Other' },
];

export const INCIDENT_REASONS = [
    { "key": "select", "value": "Select an issue ..." },
    { "key": "1", "value": "Item not received" },
    { "key": "2", "value": "Item not as ordered" },
    { "key": "3", "value": "Defective item" },
    { "key": "5", "value": "Counterfeit item" },
    { "key": "6", "value": "Delivery took longer than expected" },
    { "key": "20", "value": "Question about delivery" },
    { "key": "21", "value": "Cancel the order" },
    { "key": "22", "value": "Issue with the item received" },
    { "key": "25", "value": "Information on the product" },
    { "key": "26", "value": "Other question" },
    { "key": "27", "value": "I didn't receive my return shipping label" }
];

export const RETURN_REVIEW_STEPS = [
    'Box your item and attach the provided prepaid shipping label. Drop it off at a courier location.',
];

export const RETURN_CONFIRMATION_STEPS = [
    'Print the prepaid return shipping label included in your return confirmation email.',
    'Follow the return instructions and ship your return to the carrier indicated on the shipping label.',
    'After the item is received and inspected, your refund will be processed.',
];

export const INCIDENT_CONFIRMATION_STEPS = [
    'Your request has been submitted successfully. You will receive an email confirmation from our team.',
    'Depending on the issue, you may also receive a follow-up communication directly from the third-party seller.',
    'You should expect a response within 48 hours.',
];

export const RETURN_REVIEW_METHOD = 'Return Method';

export const RETURN_REVIEW_METHOD_DESCRIPTION = 'Return via Prepaid Shipping Label';

export const RETURN_ESTIMATE =
    'This is an estimate. Actual refund amount is subject to applied discounts, tax, shipping costs, and item condition.';

export const RETURN_NOT_ELIGIBLE = 'These items are no longer eligible for return.';

export const RETURN_WINDOW_TEXT =
    'These items are past the 30-day return policy and no longer eligible for return.';

export const RETURN_IN_STORE_TEXT = 'Items are not eligible for in-store returns.';

export const orderStatusTypes = {
    CANCEL: 'cancelled',
    PAYMENTDECLINED: 'declined',
};

export const INCIDENT_DUPLICATE_ERROR = 'This issue has already been reported.';
export const INCIDENT_GENERIC_ERROR =
    'We were unable to submit your request. Please try again later.';
